<template>
    <div class="sideContainerBuy" :class="{ 'sideContainerBuyShow': showContainer }">
        <div class="mobileOrder" :class="{ 'mobileOrderHidden': showContainer }">
            <div class="mobileBarWrapper">
                <div class="priceMobile">
                    <h4 class="price">{{ fetchDataListing.price }}€</h4>
                </div>
                <div class="listingTitle">
                    <p>{{ fetchDataShop.shopName }}</p>
                </div>
                <button @click="isStockAvailable">
                    {{ translate('order.addToOrder') }}
                </button>
            </div>
        </div>
        <div class="tabContent" id="Basic">
            <div 
                class="notificationArea" 
                :class="{ annoucementsHidden: !notifArea }"
            >
                <p>{{ translate('notification') }}</p>
            </div>
            <div 
                class="errors"
                :class="{ errorsVisible: error }"
            >
                <p>{{ errors }}!</p>
            </div>
            <div v-if="!addedToOrder">
                <div class="orderData">
                    <div class="singleData">
                        <p style="text-decoration: none;">
                           <i class="pi pi-box"></i> {{ translate('order.stockQuantity') }}
                        </p>
                        <p>
                            {{ fetchDataListing.availableQuantity }} tk
                        </p>
                    </div>
                    <div class="singleData">
                        <p @click="showDeliveryTime()"><i class="pi pi-send"></i> {{ translate('order.deliveryTime') }}</p>
                        <p>{{ fetchDataListing.deliveryTime }} {{ translate('order.days') }}</p>
                    </div>
                    <div class="singleData">
                        <p @click="showTaxNr()" v-if="fetchDataShop.legalEntity.taxNr">
                            <i class="pi pi-barcode"></i> {{ translate('order.vatIncluded') }}
                        </p>
                        <p @click="showTaxNr()" v-else>
                            <i class="pi pi-barcode"></i> {{ translate('order.vatExcluded') }}
                        </p>
                        <p>{{ calculateVAT() }} €</p>
                    </div>
                    <div class="singleData">
                        <p><i class="pi pi-clone"></i> Kogus</p>
                        <div class="qty">
                            <div class="chooseQty">
                                <div class="chooseQtyDiv">
                                    <numericInput ref="numericInputComp" @input="numericInput" :val="1" v-model="quantity" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="singleData" id="singleDataTotal">
                        <p style="color: rgb(25 ,25 ,25)">{{ translate('order.total') }}</p>
                        <p>{{ round(fetchDataListing.price * quantity, 2) }} €</p>
                    </div>
                </div>
                <div class="addToOrderFlex">
                    <div class="buyBtn" v-if="!fetchDataListing.attr.isProductNotInStock">
                        <button class="buyBtnArticle" @click="isStockAvailable">
                            <div 
                                class="loader"
                                v-if="loaderActive" 
                            ></div>
                            <b v-else><i class="pi pi-cart-arrow-down" style="margin-right: 15px;"></i>{{ translate('order.addToOrder') }}</b>
                        </button>
                    </div>
                    <div class="buyBtn" v-if="fetchDataListing.attr.isProductNotInStock">
                        <button class="buyBtnArticle" style="background: steelblue">
                            <div 
                            class="loader"
                            v-if="loaderActive" 
                            ></div>
                            <b v-else>{{ translate('order.emptyStock') }}</b>
                        </button>
                    </div>
                </div>
            </div>
            <div :class="{ 'fowardBtns': addedToOrderDelyed, 'fowardBtnsHidden': !addedToOrderDelyed }" v-if="addedToOrder">
                <img 
                    class="closeBtn"
                    @click="addedToOrder = false; notifArea = false; quantity = 1"
                    height="16px"
                    width="16px"
                    :src="require('@/assets/icons/closeX.svg')" 
                    alt=""
                >
                <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" v-if="successIcon">
                    <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
                    <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                </svg>
                <div class="buttons">
                    <!-- <button @click="$emit('openCartSidebar')">
                        {{ translate('order.openOrder') }}
                    </button> -->
                    <button @click="formalizeOrder" style="background: #64C3A2">
                        {{ translate('order.formalizeOrder') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <Dialog
        v-model:visible="visibleTaxNr"
        dismissableMask="true"
        position="right"
        modal
        :header="translate('dialog.legalEntityHeader')"
        :style="{ width: '50rem' }"
        :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
    >
        <p>
            {{ translate('dialog.legalEntityInfo.name') }}: {{ fetchLegalEntity.name }}
        </p>
        <p>
            {{ translate('dialog.legalEntityInfo.address') }}: {{ fetchLegalEntity.streetAddress.addressAsString }}
        </p>
        <p>
            {{ translate('dialog.legalEntityInfo.taxNr') }}: {{ fetchLegalEntity.taxNr }}
        </p>
        <p>
            {{ translate('dialog.legalEntityInfo.regNr') }}: {{ fetchLegalEntity.regNr }}
        </p>
    </Dialog>
    <Dialog
        v-model:visible="visibleDeliveryTime"
        dismissableMask="true"
        position="right"
        modal
        :header="translate('dialog.deliveryTimeHeader')"
        :style="{ width: '50rem' }"
        :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
    >
        <p>{{ translate('dialog.deliveryTimeInfo') }}</p>
    </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';
import numericInput from './numericInput/inputListingQty.vue';
// import addToOrder from "../../../../apiFetches(old)/addListingToOrder";

export default {
    name: "paymentPackages",
    components: { numericInput, Dialog },
    props: {
        fetchLegalEntity: { required: false },
        fetchDataListing: { required: true },
        fetchDataShop: { required: true },
        isListingDeletedFromOrder: { default: false },
        currentLang: String
    },
    watch: {
        currentLang: {
            immediate: true,
            handler() {
                this.loadTranslations();
            },
        },
    },
    data() {
        return {
            quantity: 1,
            notifArea: false,
            error: false,
            errors: [],
            loaderActive: false,
            addedToOrder: false,
            addedToOrderDelyed: false,
            successIcon: false,
            visibleTaxNr: false,
            visibleDeliveryTime: false,
            translations: {},
        };
    },
    methods: {
        numericInput(value) {
            this.quantity = value
        },

        round(num, decimalPlaces = 0) {
            num = Math.round(num + "e" + decimalPlaces);
            return Number(num + "e" + -decimalPlaces);
        },

        calculateVAT() {
            // If no tax number, VAT is automatically 0
            if (!this.fetchLegalEntity.taxNr) {
                return 0;
            }

            // 22% VAT
            const vatRate = 0.22;
            let vatAmount = 0;

            // The total price from your cart
            const totalPrice = this.round(this.fetchDataListing.price * this.quantity, 2)

            if (this.fetchLegalEntity.displayPricesWithVAT) {
                // totalPrice is already gross (includes VAT)
                // net = totalPrice / (1 + vatRate)
                // vat = net * vatRate
                const net = totalPrice / (1 + vatRate);
                vatAmount = net * vatRate;
            } else {
                // totalPrice is net
                vatAmount = totalPrice * vatRate;
            }
            
            // standard round to two decimals:
            return Math.round(vatAmount * 100) / 100;
        },

        async loadTranslations() {
            try {
                const translations = await import(`./locales/${this.currentLang}.json`);
                this.translations = translations.default;
            } catch (error) {
                const defaultTranslations = await import('./locales/et.json');
                this.translations = defaultTranslations.default;
            }
        },
        translate(key) {
            return key.split('.').reduce((obj, part) => obj?.[part], this.translations) || key;
        },
        showTaxNr() {
            this.$emit('orderContainerClose')
            this.showContainer = false
            this.visibleTaxNr = true
        },

        showDeliveryTime() {
            this.$emit('orderContainerClose')
            this.showContainer = false
            this.visibleDeliveryTime = true
        },

        viewOrder() {
            if(!this.newOrderData) {
                this.$emit('viewOrderDesc', this.fetchDataListing.idShop, this.idListing)
                this.$emit('orderContainerClose')
                this.showContainer = false
                this.addedToOrder = false
            } else {
                this.$emit('viewOrderDesc', this.newOrderData.idOrder, this.idListing)
                this.$emit('orderContainerClose')
                this.showContainer = false
                this.addedToOrder = false
            }
        },

        formalizeOrder() {
            if(!this.newOrderData) {
                this.$router.push(`/vormistamine/0`)
            } else {
                this.$router.push(`/tellimus/vormistamine/${this.newOrderData.idOrder}/${this.fetchDataListing.idShop}`)
            }
        },

        isStockAvailable() {
            if(this.fetchDataListing.availableQuantity > 0 || this.fetchDataListing.availableQuantity == null) {
                this.addToOrderWorkaround()
            } else {
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'Toode on otsas!', 
                    detail: 'Toote laoseis on nullis ning toodet ostukorvi ei lisatud.', 
                    life: 5000 
                });
            }
        },

        addToOrderWorkaround() {
            this.$emit('logout')
            setTimeout(() => {
                this.addedToOrder = true
                this.successIcon = true
                this.addedToOrderDelyed = true
                this.notifArea = true

                this.addOrderToLocalstorage()
                setTimeout(() => {
                    this.$emit('openCartSidebar')
                }, 500)
                this.$emit("emitMenuReload")
            }, 100);
        },

        addOrderToLocalstorage() {
            const storageData = localStorage.getItem('guestOrder')
            let guestOrders = JSON.parse(storageData)

            if(!Array.isArray(guestOrders)) {
                guestOrders = []
            }

            const listingsData = {
                title: this.fetchDataListing.title, 
                img: this.fetchDataListing.coverImg,
                price: this.fetchDataListing.price, 
                idListing: this.fetchDataListing.idListing, 
                qty: this.quantity,
                attr: {dimensions: this.fetchDataListing.attr.dimensions, deliveryTime: this.fetchDataListing.deliveryTime}
            }

            const shopData = {
                shopName: this.fetchDataListing.shopName,
                shopCoverImg: this.fetchDataShop.coverImg,
                idShop: this.fetchDataListing.idShop,
                listings: [listingsData]
            }

            guestOrders.forEach((e, i) => {
                // function checkIfShopOrderExists
                if(e.idShop == this.fetchDataListing.idShop) {
                    const orderListings = guestOrders[i].listings

                    orderListings.forEach((el, index) => {
                        // function appendQtyToExistentListingInOrder
                        if(el.idListing == this.fetchDataListing.idListing) {
                            orderListings[index].qty = orderListings[index].qty + this.quantity
                            this.$toast.add({ 
                                severity: 'warn', 
                                summary: this.translate('toast.productAlreadyInOrder'), 
                                detail: '', 
                                life: 5000 
                            });
                        }
                    })
                    // function addListingToExistingOrder
                    if(!orderListings.find(e => e.idListing == this.fetchDataListing.idListing)) {
                        orderListings.push(listingsData)
                    }
                }
            })
            // function createNewOrder
            if(!guestOrders.find(e => e.idShop == this.fetchDataListing.idShop)) {
                guestOrders.push(shopData)
            }

            let string = JSON.stringify(guestOrders)
            localStorage.setItem('guestOrder', string)
        },

        // addToOrder: async function () {
        //     this.loaderActive = true
        //     addToOrder(this.idListing, this.quantity)
        //     .then((res) => {
        //         this.loaderActive = false
        //     if(res.status == 'success') {
        //         this.newOrderData = res.data.order
        //         this.addedToOrder = true
        //         this.successIcon = true
        //         this.addedToOrderDelyed = true
        //         this.$emit('openCartSidebar')
        //     }
        //     if (res.message === "Cannot add twice the same listing to the order.") {
        //         this.errors = "Toode on juba tellimuses"
        //         this.error = true
        //     } else if (res.message === "Quantity must be more than zero.") {
        //         this.errors = "Kogus peab olema suurem kui 0"
        //         this.error = true
        //     } else if (res.message === "Not possible to order from a shop that belongs to the same union that the user is a member of.") {
        //         this.errors = "Iseendalt ei ole võimalik tellida"
        //         this.error = true
        //     } else if (res.message === "Store is currently not open for orders.") {
        //         this.errors = "Pood ei ole tellimustele avatud"
        //         this.error = true
        //     } else if (res.message === "Store is not operating.") {
        //         this.errors = "Pood ei ole tellimustele avatud"
        //         this.error = true
        //     } else if (res.message === "Not possible at this moment, to create orders as a seller.") {
        //         this.errors = "Kaupleja kasutajaga ei ole võimalik oste sooritada"
        //         this.error = true
        //     } else if (res.error === "Not allowed to access.") {
        //         this.addedToOrder = true
        //         this.successIcon = true
        //         this.addedToOrderDelyed = true
        //         this.notifArea = true

        //         this.addOrderToLocalstorage()
        //         setTimeout(() => {
        //             this.$emit('openCartSidebar')
        //         }, 500)
        //         this.$emit("emitMenuReload")
        //     } else {
        //         this.notifArea = true
        //         this.$emit('openCartSidebar')
        //         this.$emit("emitMenuReload")
        //     }
        //     setTimeout(() => {
        //         this.notifArea = false
        //         this.error = false
        //         this.errors = ''
        //     },  3000);
        // });
        // },
    },
    created() {
        this.loadTranslations();
    },
};
</script>


<style scoped>
.sideContainerBuy:focus {
    outline: none;
    border: none;
}
.sideContainerBuy {
    position: relative;
    margin-top: 0px;
    z-index: 10;
    /* background: rgb(255, 255, 255);
    -webkit-box-shadow: 0px 0px 16px -5px rgba(0,0,0,0.2);
    box-shadow: 0px 0px 16px -5px rgba(0,0,0,0.2);
    border: 1px solid rgb(230, 230, 230); */
    overflow: hidden;
    border: 2px solid #05969A;
    border-left: 0;
    border-right: 0;
    border-bottom: 0;
    margin-top: 15px;
    padding-top: 15px;
    padding-bottom: 25px;
}
.mobileOrder {
    display: none;
    position: absolute;
    z-index: 500;
    height: 70px;
    background: rgb(250,250,250);
    width: 100%;
}
.mobileOrder button {
    position: absolute;
    height: 45px;
    width: 170px;
    bottom: 0;
    top: 0;
    right: 0;
    margin: auto;
    text-transform: uppercase;
    font-size: 1.05rem;
    background: #ffa437;
    border: 1px solid transparent;
    border-radius: 10px;
    color: rgb(253, 253, 253);
    font-family: 'Lato', sans-serif;
    font-weight: 400;
    cursor: pointer;
    -webkit-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.25);
    box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.25);
}
.mobileBarWrapper {
    position: relative;
    width: 90%;
    height: 70px;
    margin: 0 auto;
}
.notificationArea {
  position: absolute;
  z-index: 20;
  top: -17px;
  width: 100%;
  text-align: center;
  background: #64c3a2;
  padding-top: 13px;
  padding-bottom: 5px;
  color: white;
  font-family: "Quicksand", sans-serif;
  font-weight: bold;
  font-size: 1.2rem;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
}
.notificationArea p {
    padding-top: 7px;
    padding-bottom: 7px;
    margin: 0;
}
.annoucementsHidden {
  position: absolute;
  z-index: 20;
  top: -98px;
  width: 100%;
  text-align: center;
  background: #64C3A2;
  padding-top: 13px;
  padding-bottom: 5px;
  color: white;
  font-family: "Quicksand", sans-serif;
  font-weight: bold;
  font-size: 1.2rem;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
}
.errors {
    position: absolute;
    z-index: 20;
    top: -98px;
    width: 100%;
    text-align: center;
    background: #ff5252;
    padding-top: 13px;
    padding-bottom: 5px;
    color: white;
    font-family: "Quicksand", sans-serif;
    font-weight: bold;
    font-size: 1.2rem;
    -webkit-transition: .3s;
    -o-transition: .3s;
    transition: .3s;
}
.errors p {
    padding-top: 7px;
    padding-bottom: 7px;
    margin: 0;
}
.errorsVisible {
    position: absolute;
    z-index: 20;
    top: -17px;
    width: 100%;
    text-align: center;
    background: #ff5252;
    padding-top: 13px;
    padding-bottom: 5px;
    color: white;
    font-family: "Quicksand", sans-serif;
    font-weight: bold;
    font-size: 1.2rem;
    -webkit-transition: .3s;
    -o-transition: .3s;
    transition: .3s;
}
.errorsVisible p {
    padding-top: 7px;
    padding-bottom: 7px;
    margin: 0;
}
.price {
    width: 250px;
    margin: 0;
    margin: 0 auto;
    margin-top: 15px;
    margin-bottom: 0px;
    text-align: start;
    font-size: 1.7rem;
    font-family: 'Lato', sans-serif;
    font-weight: 400;
    padding-bottom: 5px;
    color: rgb(50,50,50);
    border-bottom: 1px solid rgb(230,230,230);
}
.priceMobile .price {
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    margin: 0;
    border: none;
    position: absolute;
    top: 10px;
    left: -2px;
    padding: 0;
}
.nameContainer {
    width: 250px;
    position: absolute;
    top: 10px;
    right: 0;
    left: 0;
    margin: auto;
    text-align: end;
}
.nameContainer h4 {
    margin: 0;
    padding-left: 100px;
    font-size: 1.1rem;
    font-family: 'DM sans', sans-serif;
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    color: rgb(150,150,150);
}
.listingTitle {
    width: 250px;
    margin: 0 auto;
}
.listingTitle p {
    font-size: 1rem;
    color: rgb(100,100,100);
    margin: 0;
    margin-top: 15px;
    white-space: nowrap;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    font-family: 'DM sans', sans-serif;
}
.mobileOrder .listingTitle {
    position: absolute;
    max-width: 150px;
    bottom: 7px;
    left: 0;
    margin: 0;
}
.fowardBtnsHidden {
    position: relative;
    height: 275px;
    text-align: center;
    -webkit-transition: .5s;
    -o-transition: .5s;
    transition: .5s;
    right: -450px;
}
.fowardBtns {
    position: relative;
    bottom: -0px;
    right: 0;
    height: 248px;
    text-align: center;
    -webkit-transition: .5s;
    -o-transition: .5s;
    transition: .5s;
}
.closeBtn {
    position: absolute;
    z-index: 100;
    right: 38px;
    margin-top: 50px;
    opacity: .5;
}
.closeBtn:hover {
    opacity: .7;
    cursor: pointer;
}
.successIcon {
    position: relative;
    height: 125px;
    margin-top: 25px;
    opacity: .8;
}
.buttons {
    position: absolute;
    height: 80px;
    top: 230px;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    -webkit-transition: .2s;
    -o-transition: .2s;
    transition: .2s;
}
.fowardBtns button {
    width: 250px;
    height: 30px;
    padding-bottom: 2px;
    margin-bottom: 10px;
    border: 1px solid #dddddd00;
    border-radius: 3px;
    background: rgb(255, 255, 255);
    font-size: .9rem;
    cursor: pointer;
    background: #3D4056;
    color: #EEEEEE;
    font-family: 'Lato', sans-serif;
    text-transform: uppercase;
}
.fowardBtns button:hover {
    opacity: .9;
}
.deliveryTime p {
  font-size: 0.9rem;
  margin-top: -5px;
  margin-bottom: 0px;
  color: rgb(179, 179, 179);
  text-align: center;
}
.title {
  text-align: center;
  padding-top: 11px;
  padding-bottom: 5px;
  color: rgb(62, 101, 110);
  font-size: 2rem;
  width: 100%;
  margin-top: 18px;
  margin-bottom: 0px;
  font-size: 1.5rem;
    font-family: "Quicksand", sans-serif;
}
.tabContent {
    position: relative;
    z-index: 100;
}
.buyBtnArticle {
    margin-top: 10px;
    text-transform: uppercase;
    padding-top: 10px;
    padding-bottom: 10px;
    width: 100%;
    font-size: 1.05rem;
    background: #ffa437;
    border: 1px solid transparent;
    border-radius: 10px;
    color: rgb(253, 253, 253);
    font-family: 'Lato', sans-serif;
    font-weight: 400;
    cursor: pointer;
    -webkit-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.25);
        box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.25);
}
.buyBtnArticle:hover {
  opacity: 0.9;
}
.buyBtnArticle:focus {
    outline: none;
}
.buyBtn {
  text-align: center;
  margin-top: 0px;
  margin-bottom: 0px;
  padding-bottom: 0px;
}
.buyBtn p {
  font-family: 'Lato', sans-serif;
  color: rgb(192, 192, 192);
  font-size: 0.8rem;
  margin-top: 1px;
  margin-bottom: -5px;
}
.addToOrderFlex {
    margin-top: 20px;
}
.qty {
    margin-left: auto;
}
.chooseQty {
    text-align: center;
}
.chooseQty p {
  color: rgb(175, 175, 175);
  width: 50px;
  text-align: center;
  margin-top: 0px;
  margin-bottom: 0px;
  font-size: 0.8rem;
  font-family: "Quicksand", sans-serif;
}
.orderData {
    position: relative;
}
.singleData {
    height: 35px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}
.singleData:last-child {
    padding-top: 10px;
    /* border-top: 1px solid rgb(230,230,230); */
}
.singleData p {
    margin: 0;
    color: rgb(25, 25, 25);
    font-family: "Inter", system-ui, ui-sans-serif, sans-serif;
    font-weight: 600;
    font-size: 14px;
    text-decoration: none;
}
.singleData:last-child p{
    font-weight: 500;
    font-size: 1rem;
}
.singleData p:first-child {
    position: absolute;
    cursor: pointer;
    left: 0;
    color: rgb(150,150,150);
}
.singleData p:last-child {
    position: absolute;
    right: 0;
}
.singleData:last-child p:first-child {
    text-decoration: none;
    cursor: default;
}
#singleDataTotal p {
    font-size: 28px;
    font-weight: 700;
    color: rgb(50,50,50)
}
.singleData i {
    margin-right: 10px;
    opacity: .5;
}
.loader {
    border: 6px solid #f0f0f0; /* Light grey */
    border-top: 6px solid #3498db; /* Blue */
    border-radius: 50%;
    margin: 0px auto;
    margin-bottom: .5px;
    width: 8px;
    height: 8px;
    -webkit-animation: spin 2s linear infinite;
            animation: spin 2s linear infinite;
    z-index: 10;
}
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); transform: rotate(360deg); }
}
@keyframes spin {
  0% { -webkit-transform: rotate(0deg); transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); transform: rotate(360deg); }
}

.checkmark__circle {
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke: #64C3A2;
    fill: none;
    -webkit-animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
            animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.checkmark {
    position: absolute;
    left: 0;
    right: 0;
    top: 55px;
    margin: auto;
    width: 125px;
    height: 125px;
    border-radius: 50%;
    display: block;
    stroke-width: 2;
    stroke: #64C3A2;
    stroke-miterlimit: 10;
    -webkit-box-shadow: inset 0px 0px 0px #ffffff;
            box-shadow: inset 0px 0px 0px #ffffff;
    -webkit-animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
            animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
}

.checkmark__check {
    -webkit-transform-origin: 50% 50%;
        -ms-transform-origin: 50% 50%;
            transform-origin: 50% 50%;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    -webkit-animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
            animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}

@-webkit-keyframes stroke {
    100% {
        stroke-dashoffset: 0;
    }
}

@keyframes stroke {
    100% {
        stroke-dashoffset: 0;
    }
}
@-webkit-keyframes scale {
    0%, 100% {
        -webkit-transform: none;
                transform: none;
    }
    50% {
        -webkit-transform: scale3d(1.1, 1.1, 1);
                transform: scale3d(1.1, 1.1, 1);
    }
}
@keyframes scale {
    0%, 100% {
        -webkit-transform: none;
                transform: none;
    }
    50% {
        -webkit-transform: scale3d(1.1, 1.1, 1);
                transform: scale3d(1.1, 1.1, 1);
    }
}
@-webkit-keyframes fill {
    100% {
        -webkit-box-shadow: inset 0px 0px 0px 63px #ffffff;
                box-shadow: inset 0px 0px 0px 63px #ffffff;
    }
}
@keyframes fill {
    100% {
        -webkit-box-shadow: inset 0px 0px 0px 63px #ffffff;
                box-shadow: inset 0px 0px 0px 63px #ffffff;
    }
}


/* @media only screen and (max-width: 1150px) {
    .sideContainerBuy {
        width: 250px;
    }
    .price {
        width: 225px;
    }
    .nameContainer {
        width: 225px;
    }
    .listingTitle {
        width: 225px;
    }
    .buyBtnArticle {
        width: 225px;
    }
    .orderData {
        width: 225px;
    }
    .chooseQty {
        width: 225px;
    }
}
@media only screen and (max-width: 750px) {
    .mobileOrder {
        display: initial;
    }
    .mobileOrderHidden {
        display: none;
    }
    .sideContainerBuy {
        width: 100%;
        position: fixed;
        z-index: 1050;
        bottom: -295px;
        right: 0;
        border-radius: 0px;
        -webkit-transition: .3s;
        -o-transition: .3s;
        transition: .3s;
        border: none;
        border-top: 1px solid rgb(230,230,230);
    }
    .sideContainerBuyShow {
        bottom: 0;
        padding-bottom: 10px;
        -webkit-transition: .3s;
        -o-transition: .3s;
        transition: .3s;
        border-radius: 20px 20px 0px 0px;
        border: none;
    }
    .price {
        width: 80%;
    }
    .nameContainer {
        width: 80%;
    }
    .listingTitle {
        width: 80%;
    }
    .buyBtnArticle {
        width: 80%;
    }
    .orderData {
        width: 80%;
    }
    .chooseQty {
        width: 80%;
    }
} */
</style>